import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useLocalization} from "../../../../hooks/localization"
import {NotificationLogType} from "../../../../store/control/state"
import {useRPC} from "../../../../hooks/rpc"

const keyExtractor = (item: NotificationLogType) => String(item.id)
export const NotificationLogs = memo(function NotificationLogs() {
    const [rpc] = useRPC()
    const {t} = useLocalization()
    const [notificationLogs, setNotificationLogs] = useState<NotificationLogType[]>([])
    useEffect(() => {
        rpc.getNotificationLog(100).then(r => setNotificationLogs(r))
    }, [rpc])
    const newList = notificationLogs.map(r => {
        const dateObject = new Date(r.timestamp * 1000)
        let yearString = dateObject.getFullYear().toString()
        if (yearString.length === 1) {
            yearString = "0" + yearString
        }
        let monthString = (dateObject.getMonth() + 1).toString()
        if (monthString.length === 1) {
            monthString = "0" + monthString
        }
        let dayString = dateObject.getDate().toString()
        if (dayString.length === 1) {
            dayString = "0" + dayString
        }
        let hourString = dateObject.getHours().toString()
        if (hourString.length === 1) {
            hourString = "0" + hourString
        }
        let minuteString = dateObject.getMinutes().toString()
        if (minuteString.length === 1) {
            minuteString = "0" + minuteString
        }
        const dateString = `${dayString}/${monthString}/${yearString} ${hourString}:${minuteString}`
        return {
            id: r.id,
            message: r.message,
            username: r.username,
            mobile_os: r.mobile_os,
            time: dateString,
            timestamp: r.timestamp
        }
    })
    const listSortedByTimestamp = newList.sort((a, b) => (a?.timestamp < b?.timestamp ? 1 : -1)).splice(0, 100)

    const [selectedControl, setSelectedControl] = useState<NotificationLogType>(null)
    const displayNameExtractor = useCallback((item: NotificationLogType, column: ColumnModel) => {
        if (column.key === "name") {
            return item
        }
        return item[column.key] || "-"
    }, [])

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 1,
                name: "ID",
                key: "id"
            },
            {
                length: 2,
                name: t("time"),
                key: "time"
            },
            {
                length: 1,
                name: t("user"),
                key: "username"
            },
            {
                length: 5,
                name: t("message"),
                key: "message"
            }
        ],
        [t]
    )

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer className="service-edit" buttons={[]} backUrl="/settings/logs" searchable={true}>
                <SettingsList
                    columns={columns}
                    items={listSortedByTimestamp}
                    listType="notificationLogList"
                    keyExtractor={keyExtractor}
                    displayNameExtractor={displayNameExtractor}
                    selectedItem={selectedControl}
                    onItemSelected={setSelectedControl}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
